var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
var CSSController = /** @class */ (function () {
    function CSSController() {
    }
    /*****************************************************************************************************
        * Is using route "api/css" and http method "GET" to call the back-end.
    
        * @returns {CSSDownloadDto[]}
    ******************************************************************************************************/
    CSSController.GetListOfCSS = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/css", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/css/{id}" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {CSSDownloadDto}
    ******************************************************************************************************/
    CSSController.GetCSS = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/css/{id}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/css" and http method "POST" to call the back-end.
    
        * @param {File} file
        * @param {CSSUploadDto} data
        * @returns {CSSDownloadDto}
    ******************************************************************************************************/
    CSSController.PostCSS = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.file)
            fd.append("file", data.file);
        fd.append("data", JSON.stringify(data.data));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/css", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/css/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {File} file
        * @param {CSSUploadDto} data
        * @returns {CSSDownloadDto}
    ******************************************************************************************************/
    CSSController.PatchCSS = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.file)
            fd.append("file", data.file);
        fd.append("data", JSON.stringify(data.data));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/css/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    return CSSController;
}());
export { CSSController };
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=CSSController.js.map